import 'jquery';
import Litepicker from 'litepicker';
import 'litepicker/dist/plugins/keyboardnav';

jQuery(document).ready(() => {
  const displayGridNode = (node) => {
    node.classList.add('grid');
    node.classList.remove('hidden');
  };
  const hideGridNode = (node) => {
    node.classList.add('hidden');
    node.classList.remove('grid');
  };

  // this function handles the "load more" pagination for a given filtered list of results
  const handleFilteredResultsVisibility = (results, filteredResultsCount = null) => {
    const loadMoreButton = document.getElementById('js-search-page-load-more');
    const resultsByStatus = results.reduce(
      (acc, result) => {
        const isFilteredOut = result.classList.contains('filter-hidden');
        const hidden = result.classList.contains('hidden');
        if (isFilteredOut) return acc;
        return hidden ? { ...acc, hidden: [...acc.hidden, result] } : { ...acc, visible: [...acc.visible, result] };
      },
      { hidden: [], visible: [] }
    );
    const INCREMENT = 10;
    const visibleCount = resultsByStatus.visible.length;
    const hiddenCount = resultsByStatus.hidden.length;
    const noResultsText = document.getElementById('js-no-results');
    if (filteredResultsCount) {
      if (filteredResultsCount > INCREMENT) {
        if (visibleCount >= INCREMENT) {
          resultsByStatus.visible.slice(INCREMENT - 1).forEach((result) => result.classList.add('hidden'));
        } else {
          const amountToShow = INCREMENT - visibleCount;
          noResultsText.classList.add('hidden');
          resultsByStatus.hidden.slice(0, amountToShow).forEach((result) => result.classList.remove('hidden'));
        }
        loadMoreButton.classList.remove('hidden');
      } else {
        resultsByStatus.hidden.forEach((result) => result.classList.remove('hidden'));
        noResultsText.classList.add('hidden');
        loadMoreButton.classList.add('hidden');
      }
    } else {
      if (hiddenCount >= INCREMENT) {
        const amountToShow = hiddenCount - INCREMENT < 0 ? hiddenCount : INCREMENT;
        resultsByStatus.hidden.slice(0, amountToShow).forEach((result) => result.classList.remove('hidden'));
        loadMoreButton.classList.remove('hidden');
      } else {
        resultsByStatus.hidden.forEach((result) => result.classList.remove('hidden'));
        loadMoreButton.classList.add('hidden');
        noResultsText.classList.add('hidden');
      }
    }
  };

  // fetch representants for the given thematique
  const displayRepresentantForActiveThematique = (slug) => {
    const representantsList = document.getElementById('js-representants');
    const loadingSpinner = document.querySelector('.animate-spin');
    const title = document.getElementById('js-representants-title');
    representantsList.innerHTML = '';
    loadingSpinner.classList.remove('hidden');
    $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_object.ajax_url,
      method: 'POST',
      data: { action: 'get_representants_for_active_thematique_filter', slug },
      // eslint-disable-next-line no-undef
      success: (res) => {
        representantsList.innerHTML = res;
        if (res.length) {
          displayGridNode(representantsList);
        }
        loadingSpinner.classList.add('hidden');
        title.classList.remove('hidden');
      },
      // eslint-disable-next-line no-undef
      error: (res) => {
        console.warn('error', res);
        representantsList.innerHTML = '';
        hideGridNode(representantsList);
        loadingSpinner.classList.add('hidden');
        title.classList.add('hidden');
      },
    });
  };

  // update the counter beside every post type filter
  const updatePostTypeCount = (results) => {
    const postTypeCount = results.reduce((acc, result) => {
      const postType = result.getAttribute('data-post-type');
      // we don't want to update the count when switching between post types
      const isVisible = !result.classList.contains('hidden-thematique');
      if (isVisible) acc[postType] = ++acc[postType] || 1;
      return acc;
    }, {});
    const desktopPostTypeFilters = document.getElementById('js-post-type-filters');
    desktopPostTypeFilters.querySelectorAll('.js-post-type-filter').forEach((filter) => {
      const postType = filter.getAttribute('data-post-type');
      const count = filter.querySelector('.js-post-type-count');
      count.innerHTML = postTypeCount[postType] || 0;
    });
  };

  // conditionally hide results based on filters
  const filterResults = () => {
    const url = new URL(window.location);
    const urlParams = new URLSearchParams(url.search);
    const activeFilters = {
      thematiqueId: urlParams.get('thematiqueId'),
      postType: urlParams.get('postType'),
      dateStart: urlParams.get('dateStart'),
      dateEnd: urlParams.get('dateEnd'),
    };
    const resultsList = document.getElementById('js-search-results');
    const results = Array.from(resultsList.querySelectorAll('.js-search-result'));
    let filteredResultsCount = 0;
    results.forEach((result) => {
      const thematiqueCheck = activeFilters.thematiqueId
        ? result.getAttribute('term_ids').includes(activeFilters.thematiqueId)
        : true;
      const postTypeCheck = activeFilters.postType
        ? result.getAttribute('data-post-type') === activeFilters.postType
        : true;
      let dateCheck = true;
      const timestamp = result.getAttribute('data-timestamp');
      const postDate = timestamp ? new Date(result.getAttribute('data-timestamp')) : null;
      if (postDate && activeFilters.dateStart) {
        dateCheck = postDate >= new Date(activeFilters.dateStart) && postDate <= new Date(activeFilters.dateEnd);
      }
      if (!thematiqueCheck || !dateCheck) {
        // specific class to be able to isolate thematique hidden content
        result.classList.add('hidden-thematique');
      }
      if (thematiqueCheck && dateCheck) {
        result.classList.remove('hidden-thematique');
      }
      if (thematiqueCheck && postTypeCheck && dateCheck) {
        result.classList.remove('filter-hidden');
        filteredResultsCount += 1;
      } else {
        result.classList.add('filter-hidden');
      }
    });
    handleFilteredResultsVisibility(results, filteredResultsCount);
    updatePostTypeCount(results);
  };

  // make sure the url is updated, so one can share the results of its query
  const updateSearchParams = ({ key, value }) => {
    const url = new URL(window.location);
    const urlParams = new URLSearchParams(url.search);
    if (value) {
      urlParams.set(key, value);
    } else {
      urlParams.delete(key);
    }
    url.search = urlParams;
    window.history.pushState({}, '', url);
  };

  const instantiateDatepicker = () => {
    return new Litepicker({
      element: document.getElementById('datepicker'),
      singleMode: false,
      allowRepick: true,
      delimiter: ' au ',
      format: 'D/MM/YYYY',
      lang: 'fr-FR',
      tooltipText: { one: 'jour', other: 'jours' },
      plugins: ['keyboardnav'],
      dropdowns: { minYear: 2019, maxYear: null, months: true, years: true },
      // not part of the official interface, used by a custom patch to fix keyboard focus on datepicker closing with ESC
      nextFocusElement: document.querySelector('.js-thematiques-filters .thematique--small'),
      setup: (picker) => {
        picker.on('selected', (date1, date2) => {
          const formatDate = (date) => {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
          };
          const dateStart = formatDate(date1.dateInstance);
          const dateEnd = formatDate(date2.dateInstance);
          const event = new CustomEvent('datepickerChange', { detail: { dateStart, dateEnd } });
          document.dispatchEvent(event);
        });
      },
      resetButton: () => {
        let btn = document.createElement('button');
        btn.innerText = 'Effacer';
        btn.addEventListener('click', (evt) => {
          evt.preventDefault();
          const event = new CustomEvent('datepickerChange', { detail: { dateStart: null, dateEnd: null } });
          document.dispatchEvent(event);
        });
        return btn;
      },
    });
  };
  const setFiltersOnPageLoad = ({
    datePickerInstance,
    thematiqueFilters,
    desktopPostTypeFilters,
    mobilePostTypeSelect,
  }) => {
    const url = new URL(window.location);
    const urlParams = new URLSearchParams(url.search);
    const urlParamsArray = Array.from(urlParams.entries());
    let activeFilters = {};
    urlParamsArray.forEach((param) => {
      const key = param[0];
      const value = param[1];
      const filterKeys = ['thematiqueId', 'postType', 'dateStart', 'dateEnd'];
      if (filterKeys.includes(key)) {
        activeFilters[key] = value;
      }
    });
    const shouldSetInitialFilters = Object.entries(activeFilters).some((entry) => entry[1]);
    if (shouldSetInitialFilters) {
      if (activeFilters.thematiqueId) {
        thematiqueFilters.forEach((thematiqueFilter) => {
          const filter = thematiqueFilter.querySelector(
            `.js-thematique-filter[term-id="${activeFilters.thematiqueId}"]`
          );
          filter.classList.add('active');
        });
      }
      if (activeFilters.postType) {
        const desktopFilter = desktopPostTypeFilters.querySelector(
          `.js-post-type-filter[data-post-type="${activeFilters.postType}"]`
        );
        desktopFilter.classList.add('active');
        mobilePostTypeSelect.value = activeFilters.postType;
      }
      if (activeFilters.dateStart && activeFilters.dateEnd) {
        datePickerInstance.setDateRange(activeFilters.dateStart, activeFilters.dateEnd);
      }
      filterResults();
    }
  };

  const handleThematiqueFilterChange = (thematiqueFilters) => {
    thematiqueFilters.forEach((filter) => {
      filter.addEventListener('click', (e) => {
        const target = e.target;
        if (target.classList.contains('js-thematique-filter')) {
          filter
            .querySelectorAll('.js-thematique-filter')
            .forEach((filter) => (target === filter ? null : filter.classList.remove('active')));
          if (target.classList.contains('active')) {
            target.classList.remove('active');
            const representantsList = document.getElementById('js-representants');
            representantsList.innerHTML = '';
            updateSearchParams({ key: 'thematiqueId' });
            hideGridNode(representantsList);
            filterResults();
          } else {
            target.classList.add('active');
            const thematiqueSlug = target.getAttribute('term-slug');
            const thematiqueId = target.getAttribute('term-id');
            updateSearchParams({ key: 'thematiqueId', value: thematiqueId });
            displayRepresentantForActiveThematique(thematiqueSlug);
            filterResults();
          }
        }
      });
    });
  };

  const handlePostTypeFilterChange = (desktopPostTypeFilters, mobilePostTypeSelect) => {
    desktopPostTypeFilters.addEventListener('click', (e) => {
      const target = e.target.closest('li');
      if (target.classList.contains('js-post-type-filter')) {
        desktopPostTypeFilters
          .querySelectorAll('.js-post-type-filter')
          .forEach((filter) => (target === filter ? null : filter.classList.remove('active')));
        if (target.classList.contains('active')) {
          target.classList.remove('active');
          updateSearchParams({ key: 'postType' });
          filterResults();
        } else {
          target.classList.add('active');
          const postType = target.getAttribute('data-post-type');
          updateSearchParams({ key: 'postType', value: postType });
          filterResults();
        }
      }
    });
    mobilePostTypeSelect.addEventListener('change', (e) => {
      const value = e.target.value;
      updateSearchParams({ key: 'postType', value });
      filterResults();
    });
  };

  const handleDatepickerFilterChange = () => {
    document.addEventListener('datepickerChange', (e) => {
      const dateStart = e.detail.dateStart;
      const dateEnd = e.detail.dateEnd;
      updateSearchParams({ key: 'dateStart', value: dateStart });
      updateSearchParams({ key: 'dateEnd', value: dateEnd });
      filterResults();
    });
  };

  const getFilters = () => {
    const datePickerField = document.getElementById('datepicker');
    const datePickerInstance = datePickerField ? instantiateDatepicker() : null;
    if (datePickerInstance) {
      // workaround to open the datepicker only when pressing enter, and not on focusing the element with keyboard
      datePickerField.addEventListener('keydown', (e) => {
        if (e.code === 'Enter') {
          datePickerInstance.show();
          const modal = document.querySelector('.litepicker');
          const focusElement = modal.querySelector('[tabindex="1"]');
          focusElement.focus();
        }
      })
    }
    const thematiqueFilters = document.querySelectorAll('.js-thematiques-filters');
    const desktopPostTypeFilters = document.getElementById('js-post-type-filters');
    const mobilePostTypeSelect = document.getElementById('js-post-type-select');
    return { datePickerInstance, thematiqueFilters, desktopPostTypeFilters, mobilePostTypeSelect };
  };

  const handleSearchPageFiltering = () => {
    const { datePickerInstance, thematiqueFilters, desktopPostTypeFilters, mobilePostTypeSelect } = getFilters();
    setFiltersOnPageLoad({ datePickerInstance, thematiqueFilters, desktopPostTypeFilters, mobilePostTypeSelect });
    if (thematiqueFilters) {
      handleThematiqueFilterChange(thematiqueFilters);
    }
    if (desktopPostTypeFilters && mobilePostTypeSelect) {
      handlePostTypeFilterChange(desktopPostTypeFilters, mobilePostTypeSelect);
    }
    if (datePickerInstance) {
      handleDatepickerFilterChange();
    }
  };

  const results = document.getElementById('js-search-results').querySelectorAll('.js-search-result');
  if (results.length > 0) {
    const loadMoreButton = document.getElementById('js-search-page-load-more');
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        const resultsList = document.getElementById('js-search-results');
        const resultItems = Array.from(resultsList.querySelectorAll('.js-search-result'));
        handleFilteredResultsVisibility(resultItems);
      });
    }

    handleSearchPageFiltering();
  }
});
